module.exports = __webpack_public_path__ + "img/mobile-calendar.1afe6b68.svg";